if (typeof JW === 'undefined') JW = {};
JW.JBSelect = function ($, tlg)
{
    var _pri = {};
    var publ = {};

    _pri.cname = 'JBSELECT';
    _pri.uid = '';
    _pri.tid = '';    // tag id prefix
    _pri.$tlg = null;
    _pri.$sel = null; // select
    _pri.$inp = null; // text input
    _pri.Jtai = null; // JW.TAInp
    _pri.$tgr = null; // tags group
    _pri.$lgr = null; // list group (fake select)
    _pri.opts = {
        prm: '',      // data-prompt
        plh: '',      // tah input placeholder
        mlt: false,   // is multiple
        tah: false,   // select will be filled by typeahead
        url: '',      // tah ajax url
        min: 2,       // min tah query length
        exm: false,   // only accept exact matches
        ppl: 'top',   // no-exact-match warn message placement
        // not implemented cas: false,   // case sensitive input, def false
        coe: false,   // close on enter

        dbg_lvl: 1
    };
    _pri.tag_pat = '<span class="label label-default"></span>';
    _pri.tag_close_pat = '<i class="tag-close"></i>';
    _pri.tah_class = 'jws-tah';
    _pri.items_map = {};
    _pri.items_map_rev = {};
    _pri.items_map_tmp = {};
    _pri.items_map_buff = {};
    _pri.inp_buff = '';
    _pri.$tlg = $(tlg);
    _pri.inited = false;
    _pri.disabled = false;

    _pri.extend = function()
    {
        JW.ExtCommon(jQuery, publ, _pri);
    };

    _pri.init = function()
    {
        if (_pri.inited)
        {
            return;
        }
        _pri.inited = true;

        _pri.uid = JW.Page.getUId();
        _pri.tid = 'tag-' + _pri.uid + '-';
        _pri.dbg('******** init() uid: ' + _pri.uid + ' ***');

        _pri.$sel = _pri.$tlg.find('select');
        if (_pri.$sel.length != 1)
        {
            _pri.dbg('!!! init(): missing select - return!');
            return;
        }

        _pri.$sel.data('JBSelect', publ);

        if (typeof _pri.$sel.data('prompt') != 'undefined')
        {
            _pri.opts.plh = _pri.$sel.data('prompt');
            _pri.opts.prm = '<span class="tags-group-prompt">' + _pri.$sel.data('prompt') + '</span>';
        }

        if (typeof _pri.$sel.data('coe') != 'undefined' && _pri.$sel.data('coe'))
        {
            _pri.opts.coe = true;
        }

        if (typeof _pri.$sel.data('url') != 'undefined' && _pri.$sel.data('url') != '')
        {
            _pri.opts.tah = true;
            _pri.opts.url = _pri.$sel.data('url');
            if (typeof _pri.$sel.data('exm') != 'undefined' && _pri.$sel.data('exm'))
            {
                _pri.opts.exm = true;
                if (typeof _pri.$sel.data('ppl') != 'undefined' && _pri.$sel.data('ppl') != '')
                {
                    _pri.opts.ppl = _pri.$sel.data('ppl');
                }
            }
        }

        _pri.opts.mlt = (typeof _pri.$sel.attr('multiple') != 'undefined');

        _pri.$tgr = $('<div class="well tags-group" tabindex="0"><span class="caret"></span></div>').insertBefore(_pri.$sel);
        if (_pri.opts.tah)
        {
            _pri.$tgr.addClass(_pri.tah_class);
        }

        //_pri.dbg('tgr: ', _pri.$tgr);

        _pri.lgrCreate();

        if (!_pri.opts.tah)
        {
            // programmatically remove options won't trigger ... !? also not by line below ...
            // _pri.$tlg.on('change', 'select', function()
            _pri.$sel.change(publ.optionsChanged);
        }

        $(document).click(function (e)
        {
            if (_pri.disabled)
            {
                return;
            }

            //_pri.dbg('         document.on(click)');
            if (_pri.$lgr.is(":visible") || (_pri.$tgr.hasClass('active') && _pri.opts.tah && !_pri.opts.mlt))
            {
                if (_pri.opts.mlt)
                {
                    // if the target of the click isn't the container && nor a descendant of the container
                    if (!_pri.$lgr.is(e.target) && !_pri.$tgr.is(e.target)
                        && _pri.$lgr.has(e.target).length === 0 && _pri.$tgr.has(e.target).length === 0)
                    {
                        //_pri.dbg('*** hide lgr!');
                        //_pri.addTagManual(); // do not add a remaining word after blur ???
                        _pri.lgrClose();
                    }
                }
                else
                {
                    if (!_pri.$tgr.is(e.target) && _pri.$tgr.has(e.target).length === 0
                        && (_pri.$inp == null || (!_pri.$inp.is(e.target) && _pri.$inp.has(e.target).length === 0)))
                    {
                        _pri.dbg('*** hide lgr!');
                        _pri.addTagManual();
                        _pri.lgrClose();
                    }
                }
            }
        });

        $(document).on('keydown', function (e)
        {
            _pri.dbg('******** $(document).on(keydown)');
            if (_pri.disabled)
            {
                return;
            }
            //_pri.dbg('         document.on(keydown)');
            if (_pri.$lgr.is(":visible"))
            {
                var kc = e.keyCode;
                if (kc == 40 || kc == 38) // DOWN UP
                {
                    if (!_pri.opts.tah)
                    {
                        //_pri.dbg('document catched keycode: ', kc);
                        e.preventDefault();
                        //_pri.$lgr.focus();
                        _pri.lgrKeyNav(kc);
                        return false;
                    }
                }
                else if (kc == 13) // ENTER
                {
                    _pri.dbg('    kc = 13, ENTER');
                    if (!_pri.opts.tah)
                    {
                        e.preventDefault();
                        var $item = _pri.$lgr.find('li.list-group-item.focus');
                        if ($item.length == 1)
                        {
                            _pri.dbg('    item trigger CLICK');
                            $item.trigger('click');
                        }
                        if (!_pri.opts.mlt)
                        {
                            _pri.lgrClose();
                        }
                        return false;
                    }
                }
                else if (kc == 9) // TAB
                {
                    _pri.dbg('    kc = 9, TAB');
                    if (_pri.opts.tah)
                    {
                        _pri.addTagManual();
                    }
                    else
                    {
                        var $item = _pri.$lgr.find('li.list-group-item.focus');
                        if ($item.length == 1)
                        {
                            _pri.dbg('    item trigger CLICK');
                            $item.trigger('click');
                        }
                    }
                    _pri.lgrClose();
                }
                else if (kc == 27) // ESC
                {
                    if (_pri.opts.tah)
                    {
                        // ? do not add the remainder on blur ...?
                        //_pri.$inp.val(_pri.inp_buff);
                        //_pri.addTagManual();
                    }
                    _pri.lgrClose();
                }
                else if (kc == 8) // BACKSPACE
                {
                    if (!_pri.opts.tah)
                    {
                        e.preventDefault();
                        return false;
                    }
                    else if (_pri.opts.tah && !_pri.$inp.is(':focus'))
                    {
                        e.preventDefault();
                        _pri.$inp.focus();
                        //_pri.$inp.val(_pri.$inp.val());
                        return false;
                    }

                }
            }
        });

        _pri.$tgr.on('click', _pri.tgrClick);
        _pri.$tgr.on('keyup', function(e)
        {
            if (e.keyCode == 9)
            {
                _pri.$tgr.trigger('click');
            }
        });
        _pri.$tgr.on('focusout', function(e)
        {
            if (!_pri.$lgr.is(":visible"))
            {
                _pri.$tgr.removeClass('active');
            }
        });
        //_pri.$tgr.on('focusin', _pri.tgrFocus);

        if (!_pri.opts.mlt)
        {
            _pri.$tlg.addClass('single');
        }

        _pri.checkPrompt();
        _pri.$sel.change();
    };

    publ.optionsChanged = function()
    {
        _pri.dbg('******** optionsChanged()');
        //_pri.dbg('vals: ', _pri.$sel.val());
        if (!_pri.opts.mlt)
        {
            _pri.lgrClose();
        }
        _pri.items_map_tmp = {};

        _pri.$sel.find('option:selected').each(function ()
        {
            var $this = $(this);
            if ($this.length)
            {
                //var selText = $this.text();
                //_pri.dbg(selText, $this.val());
                _pri.items_map_tmp[$this.val()] = { val: $this.val(), txt: $this.text() };
            }
        });
        _pri.changeTags();
    };

    _pri.tgrClick = function(e)
    {
        _pri.dbg('******** tgrClick()');
        //e.preventDefault();
        //e.stopPropagation();

        if (_pri.disabled)
        {
            return;
        }

        if(e.type == "click")
        {
            _pri.dbg('click');
        }
        else
        {

        }

        if (_pri.$tgr.is(e.target) || _pri.$tgr.find('.caret').is(e.target) || _pri.$tgr.find('.tags-group-prompt').is(e.target) || _pri.$tgr.find('span.single').is(e.target) || _pri.$tgr.find('input.jb-tah-inp').is(e.target))
        {
            if (_pri.opts.tah && !_pri.opts.mlt && !_pri.$lgr.is(":visible"))
            {
                _pri.$tgr.addClass('active');
                _pri.$inp.focus();
                //_pri.$inp.val(_pri.$inp.val());
                _pri.$inp.trigger('input');
            }
            else
            {
                if (_pri.$lgr.is(":visible"))
                {
                    _pri.addTagManual();
                    _pri.lgrClose();
                }
                else
                {
                    _pri.lgrOpen();
                }
            }
        }
    };

    // sometimes those keys visible for the form aren't really keys and we
    // need the values instead, but iterating over selected options is'nt convenient at all
    publ.getItemsMap = function()
    {
        return _pri.items_map;
    };

    publ.on = function(enm, cb)
    {
        if (_pri.inited)
        {
            _pri.dbg('******** on set cb to ' + enm);
            _pri.$tlg.on(enm, cb);
        }
    };

    publ.setDataUrl = function($url)
    {
        _pri.opts.tah = true;
        _pri.opts.url = $url;
        if (typeof _pri.$sel.data('exm') != 'undefined' && _pri.$sel.data('exm'))
        {
            _pri.opts.exm = true;
            if (typeof _pri.$sel.data('ppl') != 'undefined' && _pri.$sel.data('ppl') != '')
            {
                _pri.opts.ppl = _pri.$sel.data('ppl');
            }
        }
    };

    publ.setDisabled = function(dis)
    {
        _pri.disabled = dis;
    };

    /*
     * click close button on tags for multiple
     */
    _pri.tagCloseClick = function(o)
    {
        if (!_pri.opts.tah)
        {
            _pri.$sel.find("option[value='" + o.val + "']").prop("selected", false);
            _pri.$sel.change();
        }
        else
        {
            _pri.removeTag(o.val);
            _pri.syncItemsMap2TgrSel();
        }

        if (_pri.opts.tah && !_pri.$lgr.is(":visible"))
        {
            _pri.dbg('trigger jbselect:tags_changed');
            _pri.$tlg.trigger('jbselect:tags_changed');
        }
    };

    _pri.changeTags = function()
    {
        _pri.dbg('******** changeTags()');

        var p;
        for (p in _pri.items_map)
        {
            if (!_pri.items_map_tmp.hasOwnProperty(p))
            {
                _pri.removeTag(p)
            }
        }
        for (p in _pri.items_map_tmp)
        {
            if (!_pri.items_map.hasOwnProperty(p))
            {
                _pri.addTag(_pri.items_map_tmp[p]);
            }
        }

        //_pri.dbg('items_map: ', _pri.items_map);
        //_pri.dbg('END-changeTags()');
    };

    // NEXT switch here or the call above for tah ...

    _pri.addTag = function(o)
    {
        _pri.dbg('******** addTag() o: ', o);

        _pri.items_map[o.val] = o;
        _pri.items_map_rev[o.txt] = o.val;

        if (_pri.opts.tah && !_pri.opts.mlt)
        {
            _pri.$inp.val(o.txt);
            _pri.$inp.blur();
            return;
        }

        _pri.checkPrompt();

        var $tag;
        if (_pri.opts.mlt)
        {
            $tag = $('<span id="' + _pri.tid.toString() + o.val + '" class="label label-default"></span>');
            $tag.html(o.txt + _pri.tag_close_pat);
            $tag.find('i.tag-close').click(function(e)
            {
                e.preventDefault();
                _pri.tagCloseClick(o);
                return false;
            });
        }
        else
        {
            $tag = $('<span id="' + _pri.tid.toString() + o.val + '" class="single"></span>');
            $tag.html(o.txt);
            if (!_pri.opts.tah && (o.val == '' || _pri.$sel.find("option[value='" + o.val + "']").hasClass('tags-group-prompt')))
            {
                $tag.addClass('tags-group-prompt');
            }
        }
        _pri.$tgr.append($tag);
    };

    _pri.addTagManual = function()
    {
        _pri.dbg('******** addTagManual()');

        if (!_pri.opts.tah || '' == $.trim(_pri.$inp.val()))
        {
            return false;
        }

        var arr;

        if (_pri.opts.mlt)
        {
            arr = _pri.$inp.val().split(',');

            if (0 == arr.length)
            {
                return false;
            }

            _pri.$inp.val('');
            //_pri.lgrClear();
        }
        else
        {
            var p;
            for (p in _pri.items_map)
            {
                _pri.removeTag(p);
            }

            arr = [_pri.$inp.val()];
        }

        $.each(arr, function(k, v)
        {
            var txt = $.trim(v);

            //_pri.dbg('*** _pri.addTagManual() txt: ', txt);
            if (txt in _pri.items_map_rev)
            {
                _pri.removeTag(_pri.items_map_rev[txt]);
                return 'continue'; // ugly continue equivalent ...
            }

            var obj = null;

            if (txt.length > 1)
            {
                var id = _pri.Jtai.getIdFor(txt);
                if (id == '')
                {
                    if (_pri.opts.exm)
                    {
                        _pri.jssNoMatch();
                        return false;
                    }
                    else
                    {
                        id = '_' + JW.Page.getUId();
                    }
                }
                obj = {val: id, txt: txt};

                //_pri.dbg('    obj: ', obj);
            }
            else if (_pri.opts.exm)
            {
                _pri.jssNoMatch();
                return false;
            }

            if (obj != null)
            {
                _pri.addTag(obj);
            }
        });

        _pri.syncItemsMap2TgrSel();
    };

    _pri.jssNoMatch = function()
    {
        _pri.dbg('******** jssNoMatch()');
        var cur_val = _pri.$inp.val();
        _pri.$inp.val('');
        _pri.$inp.popover({
            content: '<b>"' + cur_val + '"</b> konnte nicht gefunden werden. Bitte wählen Sie einen entsprechenden Eintrag aus den Vorschlägen aus.',
            title: 'Hinweis <span class="close">&times;</span>',
            html: true,
            //placement: _pri.opts.ppl,
            placement: function(dn, te) {
                            if (JW.ViewPort.isgt('md'))
                            {
                                return _pri.opts.ppl;
                            }
                            return 'top';
                       },
            trigger: 'manual'
        }).on('shown.bs.popover', function(e) {
            _pri.$tgr.find('div.popover .close').on('click', function(e) {
                _pri.$inp.popover('hide');
                _pri.$inp.focus();
                //_pri.$inp.val(_pri.$inp.val());
            });
        });
        _pri.$inp.popover("show");
    };

    _pri.removeTag = function(p)
    {
        //_pri.dbg('*** _pri.removeTag() p: ', p);
        var o = _pri.items_map[p];
        delete _pri.items_map_rev[o.txt];
        delete _pri.items_map[p];
        $('#' + _pri.tid.toString() + p + '').remove();
        _pri.checkPrompt();
    };

    _pri.syncItemsMap2TgrSel = function()
    {
        _pri.dbg('******** syncItemsMap2TgrSel()');

        _pri.$sel.find('option').remove();
        _pri.$lgr.find('.list-group-item.active').removeClass('active');
        $.each(_pri.items_map, function(k, v)
        {
            _pri.$sel.append('<option value="'+v.val+'" selected="selected">'+v.txt+'</option>');
            if (true || _pri.opts.mlt)
            {
                _pri.$lgr.find(".list-group-item[data-value='"+v.val+"']").addClass('active');
            }
        });
    };

    _pri.checkPrompt = function()
    {
        if (_pri.opts.prm == '' || !_pri.opts.mlt)
        {
            return;
        }

        if (Object.keys(_pri.items_map).length === 0)
        {
            if (_pri.$tgr.has('.tags-group-prompt').length === 0)
            {
                _pri.$tgr.append(_pri.opts.prm);
            }
        }
        else
        {
            _pri.$tgr.find('.tags-group-prompt').remove();
        }
    };

    _pri.lgrCreate = function()
    {
        _pri.$lgr = $('<ul>').addClass('list-group anim jb-dd');

        if (_pri.opts.tah)
        {
            _pri.$lgr.addClass('jb-tah');

            _pri.$inp = $('<input type="text" autocomplete="false" class="form-control jb-tah-inp" value="" placeholder="">');
            if (_pri.opts.mlt)
            {
                _pri.$inp.addClass('mlt');
                _pri.$lgr.append(_pri.$inp);
            }
            else
            {
                _pri.$tgr.addClass('jb-tah-single');
                _pri.$inp.attr('placeholder', _pri.opts.plh);
                _pri.$tgr.append(_pri.$inp);
            }
            _pri.Jtai = JW.TAInp($, _pri.$inp, {
                url: _pri.opts.url
            });
            _pri.lgrInitOptionsTah();
        }
        else
        {
            _pri.lgrLoadOptions();
            _pri.$sel.change(_pri.lgrSetVal);
        }

        _pri.$sel.before(_pri.$lgr);
        _pri.$sel.hide();
        _pri.$lgr.hide();
        _pri.lgrInit();
        if (_pri.opts.tah)
        {
            _pri.inpInit();
        }
    };

    _pri.lgrInit = function()
    {
        _pri.dbg('******** lgrInit()');
        _pri.$lgr.on('click', 'li.list-group-item', function (e)
        {
            //_pri.dbg('**************** e.click()');
            var $item = $(this);

            if (!$item.hasClass('disabled'))
            {
                var add = true;

                if (_pri.opts.mlt)
                {
                    add = !$item.hasClass('active');
                }

                if (_pri.opts.tah)
                {
                    _pri.lgrItemClickTah($item, add);
                }
                else
                {
                    _pri.lgrItemClick($item.data('value'), add);
                }
            }

            //$item.blur();
            return false;
        });

        _pri.$lgr.on('mouseenter', 'li.list-group-item', function (e)
        {
            //_pri.dbg('mouseenter');
            _pri.$lgr.find('li.list-group-item.focus').removeClass('focus');
            $(this).addClass('focus');
        });
        _pri.$lgr.on('mouseleave', 'li.list-group-item', function (e)
        {
            //_pri.dbg('mouseleave');
            $(this).removeClass('focus');
        });
    };

    _pri.lgrLoadOptions = function()
    {
        _pri.lgrClear();
        _pri.$sel.find('option').each(function (i, item)
        {
            var $item = $(item);

            var $new = $('<li>')
                        .addClass('list-group-item')
                        .attr('data-value', $item.val())
                        .text($item.text());

            // forward any inline style on the source <option> (e.g. style="color:#c00000") so
            // colour-coded options stay colour-coded after the jb-select widget rebuilds them.
            var inl_style = $item.attr('style');
            if (inl_style)
            {
                $new.attr('style', inl_style);
            }

            if ($item.is(':disabled'))
            {
                $new.addClass('disabled');
            }

            if ($item.css('display') === 'none')
            {
                $new.addClass('hidden');
            }

            if ($item.hasClass('tags-group-prompt'))
            {
                $new.addClass('tags-group-prompt');
            }

            _pri.$lgr.append($new);
        });
    };

    _pri.lgrInitOptionsTah = function()
    {
        _pri.lgrClear();
        _pri.items_map_tmp = {};
        _pri.$sel.find('option').each(function (i, item)
        {
            var $item = $(item);
            if ($item.val() != '' && $item.text() != '' && !$item.is(':disabled') && $item.css('display') !== 'none')
            {
                _pri.items_map_tmp[$item.val()] = {val: $item.val(), txt: $item.text()};
                _pri.Jtai.initRecord({id: $item.val(), label: $item.text()});
            }
        });
        _pri.changeTags();
        //_pri.dbg('END-lgrInitOptionsTah()');
    };

    _pri.stripTags = function(str)
    {
        return str.replace(/[<>]/g, '');
    };

    _pri.inpInit = function()
    {
        _pri.dbg('******** inpInit()');

        _pri.$inp.on('focusin', function()
        {
            //_pri.dbg('    $inp.on(focusin)');
            _pri.$tgr.addClass('active');
        });

        _pri.$inp.on('input', function(e)
        {
            //_pri.dbg('    $inp.on(input)');

            _pri.$inp.val(_pri.stripTags(_pri.$inp.val()));

            _pri.inp_buff = _pri.$inp.val();

            //_pri.dbg(_pri.$inp.data('bs.popover'));
            if (typeof _pri.$inp.data('bs.popover') != 'undefined')
            {
                _pri.$inp.popover('destroy');
            }
            var query = _pri.cleanQuery(_pri.$inp.val());
            if (query.length < _pri.opts.min)
            {
                if (_pri.opts.tah && !_pri.opts.mlt)
                {
                    //_pri.dbg('_pri.$inp.on input -> lgr.close');
                    _pri.lgrClose();
                }
                _pri.lgrClear();
                return false;
            }
            _pri.Jtai.onInput(query);
        });

        _pri.$inp.on('tai:response', function(e, q)
        {
            //_pri.dbg('    $inp.on(tai:response)');

            var query = _pri.cleanQuery(_pri.$inp.val());
            //_pri.dbg('******** tai:response *** q: ', q, ' query: ', query);
            if (q != query)
            {
                // delayed response ...
                //_pri.dbg('!!! delayed response ...');
                return;
            }

            _pri.lgrClear();

            var arr = _pri.Jtai.getItemsList(query);
            //_pri.dbg(arr);

            $.each(arr, function(k, v)
            {
                var $new = $('<li>')
                            .addClass('list-group-item')
                            .attr('data-value', v.id)
                            .attr('data-label', v.label)
                            .html(_pri.markMatch(v.label, query));

                if (v.id in _pri.items_map && _pri.opts.mlt)// || (!_pri.opts.mlt && v.label == query))
                {
                    $new.addClass('active');
                }

                _pri.$lgr.append($new);
            });

            if (_pri.$tgr.hasClass('active'))
            {
                if (arr.length > 0 && !_pri.$lgr.is(":visible"))
                {
                    _pri.lgrOpen();
                }
                else if (arr.length == 0 && _pri.$lgr.is(":visible") && _pri.opts.tah && !_pri.opts.mlt)
                {
                    _pri.lgrClose();
                }
            }
        });

        _pri.$inp.on('keydown', function(e)
        {
            //_pri.dbg('    $inp.on(keydown)');
            var kc = e.keyCode;
            if (kc == 13)
            {
                e.preventDefault();
                _pri.addTagManual();
                if (!_pri.opts.mlt || _pri.opts.coe)
                {
                    _pri.lgrClose();
                }
                return false;
            }
            else if (kc == 38 || kc == 40)
            {
                e.preventDefault();
                //_pri.$lgr.focus();
                _pri.lgrKeyNav(kc);
                return false;
            }
        });
    };

    _pri.markMatch = function(str, query)
    {
        var rx = new RegExp(RegExp.escape(query), 'i');
        return str.replace(rx, '<b>' + "$&" + '</b>');
    }

    _pri.cleanQuery = function(str)
    {
        return str.replace(/ \|.*$/, '');
    };

    _pri.lgrClear = function()
    {
        _pri.dbg('******** lgrClear()');
        _pri.$lgr.find('li').remove();
    };

    _pri.lgrItemClick = function(v, add)
    {
        _pri.dbg('******** lgrItemClick() v: ', v);
        var values;

        if (!_pri.opts.mlt)
        {
            values = v;
        }
        else
        {
            values = [];

            _pri.$lgr.find('.list-group-item.active').each(function(i, item)
            {
                var value = $(item).data('value');
                if (add || value != v)
                {
                    values.push(value);
                }
            });

            if (add)
            {
                values.push(v);
            }

            if (values.length == 1)
            {
                values = values[0];
            }
        }

        //_pri.dbg('lgrItemClick() values: ', values);
        _pri.$sel.val(values);
        _pri.$sel.change();
    }

    _pri.lgrItemClickTah = function($item, add)
    {
        _pri.dbg('******** lgrItemClickTah()');

        var o = { val: $item.data('value'), txt: $item.text() };
        //_pri.dbg('*** _pri.lgrItemClickTah() o: ', o);
        //_pri.dbg('    add? : ', add);


        _pri.items_map_tmp = {};

        if (!_pri.opts.mlt)
        {
            _pri.items_map_tmp[o.val] = o;
            _pri.$inp.val(o.txt);
            _pri.$inp.trigger('input');
        }
        else
        {
            $.each(_pri.items_map, function(k, v)
            {
                if (add || o.val != v.val)
                {
                    _pri.items_map_tmp[v.val] = v;
                }
            });

            if (add)
            {
                _pri.items_map_tmp[o.val] = o;

                // maybe it's cleaner to preserve input and results list ...?
                //_pri.$inp.val(o.txt);
                //_pri.$inp.trigger('input');
                //_pri.$inp.val('');
                if (!_pri.opts.exm)
                {
                    //??? _pri.$inp.focus();
                }
            }
        }

        if (!_pri.opts.mlt)
        {
            _pri.lgrClose();
        }

        //_pri.dbg('    items_map: ',_pri.items_map);
        //_pri.dbg('    items_map_tmp: ',_pri.items_map_tmp);

        _pri.changeTags();
        _pri.syncItemsMap2TgrSel();
    }

    _pri.lgrSetVal = function()
    {
        _pri.dbg('******** lgrSetVal()');
        var map = {};
        var val = _pri.$sel.val();
        //_pri.dbg('*** _pri.lgrSetVal() ***', val);
        var val_changed = false;

        if (typeof val === 'string')
        {
            val = [val];
        }

        if (Array.isArray(val))
        {
            var v;
            var $lgri;
            for (var i in val)
            {
                v = val[i];
                map[v] = 1;
                $lgri = _pri.$lgr.find(".list-group-item[data-value='" + v + "']");
                if ($lgri.length > 0 && !$lgri.hasClass('active'))
                {
                    val_changed = true;
                    $lgri.addClass('active');
                }
            }
        }

        _pri.$lgr.find('.list-group-item.active').each(function(i, item)
        {
            var $item = $(item);
            if (!map.hasOwnProperty($item.data('value')))
            {
                val_changed = true;
                $item.removeClass('active');
            }
        });

        if (val_changed)
        {
            _pri.dbg('         val_changed');
            _pri.$tlg.trigger('jbselect:val_changed');
        }
    };

    _pri.lgrKeyNav = function(kc)
    {
        _pri.dbg('******** lgrKeyNav() kc: ', kc);
        var $as = _pri.$lgr.find('li.list-group-item');
        if ($as.length < 1)
        {
            return;
        }

        var $afocs = _pri.$lgr.find('li.list-group-item.focus');
        $afocs.removeClass('focus');

        var $fitem = null;

        if (!_pri.opts.tah && $as.length == 1)
        {
            return;
        }

        if ($afocs.length == 0)
        {
            if (kc == 40)
            {
                $fitem = $as.first();
            }
            else
            {
                $fitem = $as.last();
            }
        }
        else
        {
            if (kc == 40)
            {
                var $nxt = $afocs.next('li.list-group-item');
                if ($nxt.length > 0)
                {
                    $fitem = $nxt;
                    //_pri.dbg('*** _pri.lgrKeyNav() next: ', $nxt);
                }
                else
                {
                    if (!_pri.opts.tah)
                    {
                        $fitem = $as.first();
                    }
                }
            }
            if (kc == 38)
            {
                var $prv = $afocs.prev('li.list-group-item');
                if ($prv.length > 0)
                {
                    $fitem = $prv;
                    //_pri.dbg('*** _pri.lgrKeyNav() prev: ', $prv);
                }
                else
                {
                    if (!_pri.opts.tah)
                    {
                        $fitem = $as.last();
                    }
                }
            }
        }

        if ($fitem != null)
        {
            $fitem.addClass('focus');
            if (_pri.opts.tah)
            {
                _pri.$inp.val($fitem.text());
            }
        }
        else if (_pri.opts.tah)
        {
            // fill input with original value ...
            _pri.dbg('    fill input buffer');
            _pri.$inp.val(_pri.inp_buff);
        }
    };

    _pri.lgrOpen = function()
    {
        _pri.dbg('******** lgrOpen()');
        _pri.items_map_buff = $.extend({}, _pri.items_map);
        _pri.$lgr.find('li.list-group-item.focus').removeClass('focus');
        _pri.$lgr.slideDown(200, function() {
            _pri.$lgr.removeClass('anim');
            _pri.$tgr.addClass('active');
            if (_pri.opts.tah)
            {
                _pri.$inp.focus();
                //_pri.$inp.val(_pri.$inp.val());
            }
        });
    };

    _pri.checkChanged = function()
    {
        _pri.dbg('******** checkChanged()');
        var changed = false;
        // for now, only value changes will be taken into account ...
        var ks0 = Object.keys(_pri.items_map);
        var ks1 = Object.keys(_pri.items_map_buff);

        if (ks0.length == ks1.length)
        {
            _pri.dbg('         same length');
            //_pri.dbg(ks0, ks1);
            var len = ks0.length;
            var i, k;
            for (i = 0; i < len; ++i)
            {
                k = ks0[i];
                /*
                _pri.dbg('     check items_map_buff k: ', k);
                _pri.dbg('     check items_map_buff has k? ', _pri.items_map_buff.hasOwnProperty(k));
                _pri.dbg('     check map, map_buff ', _pri.items_map[k], _pri.items_map_buff[k]);
                */
                if (!_pri.items_map_buff.hasOwnProperty(k) || _pri.items_map[k] != _pri.items_map_buff[k])
                {
                    changed = true;
                    break;
                }
            }
        }
        else
        {
            changed = true;
        }

        if (changed)
        {
            _pri.dbg('trigger jbselect:tags_changed');
            _pri.$tlg.trigger('jbselect:tags_changed');
        }
        else
        {
            _pri.dbg('        identical ...');
        }
    };

    _pri.lgrClose = function()
    {
        _pri.dbg('******** lgrClose()');
        if (!_pri.opts.tah || _pri.opts.mlt || !_pri.$inp.is(':focus'))
        {
            _pri.$tgr.removeClass('active');
            _pri.checkChanged();
        }
        _pri.$lgr.addClass('anim');
        _pri.$lgr.slideUp(200);
    };

    _pri.extend();
    _pri.init();
    return publ;
};
